import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostEmployeeRequirement from '.';

interface IPostEmployeeRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostEmployeeRequirements = ({
  onSuccess,
}: IPostEmployeeRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IEmployeeRequirementPayload) => {
      return PostEmployeeRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostEmployeeRequirements};
